import { useState } from 'react';
import { useFormik } from 'formik';
import { RESET_PASSWORD_INIT_VALUES } from '../../constants/auth';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { Form } from '../Form/Form';
import { Copy } from '../../copy/Copy';
import { useTheme } from '@mui/material';
import {
  marginTop16Sx,
  buttonSx,
  centerTextSx,
} from '../../styles/Global.style';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { RESET_PASSWORD_VALIDATION_SCHEMA } from '../../validation/auth';
import { Text } from '../Text/Text';
import { Password } from '../Password/Password';

export const ResetPasswordForm = ({ userEmail, handleReset }) => {
  const theme = useTheme();
  const { resetPassword } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: { ...RESET_PASSWORD_INIT_VALUES, email: userEmail },
    validationSchema: RESET_PASSWORD_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await resetPassword(
          val.email.toLowerCase(),
          val.confirmationCode,
          val.newPassword,
        );
        handleReset();
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  return (
    <FormContainer title={Copy.generate('ResetPasswordForm.title')}>
      <Text
        text={Copy.generate('ResetPasswordForm.content')}
        sx={centerTextSx}
      />
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="email"
          formik={formik}
          labelText={Copy.generate('Inputs.email')}
          inputType="email"
        />
        <FormInput
          inputFor="confirmationCode"
          formik={formik}
          labelText={Copy.generate('Inputs.confirmationCode')}
          inputType="text"
        />
        <Password
          inputFor="newPassword"
          formik={formik}
          labelText={Copy.generate('Inputs.newPassword')}
        />
        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Buttons.reset')}
          sx={{ ...buttonSx(theme), ...marginTop16Sx }}
        />
      </Form>
    </FormContainer>
  );
};
